// extracted by mini-css-extract-plugin
module.exports = {"form":"CallUploadForm_form__s16kH","checkmark":"CallUploadForm_checkmark__1CEUE"};